export default {
  tryAgain: "Riprova",
  goHome: "Vai alla home",
  loading: "Caricamento…",
  send: "Invia",
  save: "Salva",
  cancel: "Annulla",
  delete: "Elimina",
  optional: "Facoltativo",
  edit: "Modifica",
  back: "Indietro",
  refresh: "Aggiorna",
  confirm: "Conferma",
  close: "Chiudi",
  add: "Aggiungi",
  copy: "Copia",
  copySerial: "Copia seriale",
  copied: "Copiato!",
  clickToCopy: "Clicca per copiare",
  clickToCopyValue: "Copia {{value}}",
  copyFailed: "Impossibile copiare negli appunti",
  search: "Cerca",
  clearSearch: "Cancella ricerca",
  quickSearch: {
    title: "Ricerca rapida",
    placeholder: "Vai a una pagina…",
    empty: "Nessuna pagina corrispondente",
    hint: "↑↓ per navigare · Invio per aprire · Esc per chiudere",
  },
  inactive: "Inattivo",
  user: "Utente",
  privacyPolicy: "Informativa sulla privacy",
  cookiePolicy: "Informativa sui cookie",
  cookiePreferences: "Preferenze cookie",
  privacyAndCookies: "Privacy e cookie",
  privacyPolicyOpening: "Apertura informativa sulla privacy…",
  backToDashboard: "Torna alla dashboard",
  backToLogin: "Torna al login",
  copyright: "© {{year}} Flitrip. Tutti i diritti riservati.",
  language: {
    label: "Lingua",
  },
  greeting: {
    morning: "Buongiorno",
    afternoon: "Buon pomeriggio",
    evening: "Buonasera",
  },
  errorOccurred: "Si è verificato un errore",
  somethingWentWrong: "Qualcosa è andato storto. Riprova più tardi.",
  appCrashTitle: "Qualcosa è andato storto",
  appCrashMessage:
    "Riprova per ricaricare la schermata senza uscire dall’app. Se continua a fallire, aggiorna il browser o torna alla home.",
  relative: {
    justNow: "Proprio ora",
    minutesAgo: "{{count}} min fa",
    hoursAgo: "{{count}} h fa",
    daysAgo: "{{count}} g fa",
  },
  chat: {
    dayToday: "Oggi",
    dayYesterday: "Ieri",
  },
  fileSize: {
    bytes: "{{count}} B",
    kb: "{{size}} KB",
    mb: "{{size}} MB",
  },
  unsavedChanges: {
    navigationTitle: "Modifiche non salvate",
    navigationMessage:
      "Salva o annulla le modifiche prima di uscire da questa pagina.",
  },
  sectionModified: "Modificato",
  saveBar: {
    unsaved: "Modifiche non salvate",
    allSaved: "Tutto salvato",
    save: "Salva modifiche",
    saveDraft: "Salva bozza",
    revert: "Annulla modifiche",
    revertConfirmTitle: "Annullare le modifiche non salvate?",
    revertConfirmMessage:
      "Le modifiche andranno perse. Questa azione non può essere annullata.",
    revertConfirm: "Annulla modifiche",
  },
  addressAutocomplete: {
    loading: "Ricerca indirizzi…",
    error: "Impossibile caricare i suggerimenti di indirizzo.",
    noStreetResults:
      "Nessun indirizzo con via trovato. Continua a digitare o scegli un indirizzo completo dall’elenco.",
  },
  addressSearch: {
    label: "Indirizzo",
    placeholder: "Inizia a digitare per cercare un indirizzo…",
    editDetails: "Modifica dettagli indirizzo",
    detailFieldsError: "Controlla i dettagli dell’indirizzo qui sotto.",
    fieldRequired: "Questo campo è obbligatorio.",
  },
  addressValidation: {
    checking: "Verifica indirizzo…",
    valid: "Indirizzo valido",
    invalid:
      "Impossibile localizzare questo indirizzo. Controlla i dati o scegli un altro indirizzo.",
    incomplete:
      "Compila tutti i campi dell’indirizzo per convalidare la posizione.",
    saveConfirmTitle: "Indirizzo non valido",
    saveConfirmButton: "Salva comunque",
    saveWarningActivity:
      "Questo indirizzo non è valido. I clienti potrebbero non vedere questa attività nell’app perché richiede una posizione geocodificata.",
    saveWarningHouse:
      "Questo indirizzo non è valido e potrebbe non essere geocodificato correttamente. I servizi di posizione per questa struttura potrebbero non funzionare.",
  },
  editableLocation: {
    noCoordinatesWarning:
      "Scegli un indirizzo dall’elenco, digita un indirizzo riconoscibile o clicca sulla mappa per impostare la posizione.",
    mapHint:
      "Trascina il marcatore o clicca sulla mappa per regolare la posizione.",
    mapUnavailable: "Anteprima mappa non disponibile (mappa non configurata).",
    mapAriaLabel: "Mappa posizione modificabile",
  },
  map: {
    expand: "Espandi",
    expandedTitle: "Mappa",
    zoomHintCtrl: "Usa Ctrl + scroll per zoomare la mappa",
    zoomHintCmd: "Usa ⌘ + scroll per zoomare la mappa",
    panHintTouch: "Usa due dita per spostare la mappa",
  },
  environmentBanner: {
    message:
      "Sei nell'ambiente {{environment}}. Non è produzione: dati e pagamenti sono solo per test.",
    messageShort: "Sei in {{environment}}",
    productionMessage:
      "Sei in produzione. Stai usando dati reali ed elaborazione pagamenti reali — procedi con cautela.",
    productionMessageShort: "Sei in produzione",
    envNames: {
      development: "di sviluppo",
      staging: "di staging",
    },
    shortEnvNames: {
      development: "development",
      staging: "staging",
    },
  },
  region: {
    label: "Regione di pagamento",
    empty: "Nessuna regione disponibile",
    filterAll: "Tutte le regioni",
    filterLabel: "Regione",
    colCode: "Regione",
    unknown: "—",
    names: {
      IT: "Italia",
      ES: "Spagna",
    },
  },
  table: {
    paginationSummary: "Visualizzazione {{start}}-{{end}} di {{total}}",
    rowsPerPage: "Righe per pagina",
    previousPage: "Precedente",
    nextPage: "Successiva",
    pageOf: "Pagina {{page}} di {{totalPages}}",
    resizeColumn: "Ridimensiona colonna",
    resizeColumnFor: "Ridimensiona colonna {{column}}",
    preferencesOpen: "Preferenze",
    preferencesTitle: "Preferenze tabella",
    preferencesDescription:
      "Scegli quante righe mostrare e quali colonne visualizzare.",
    preferencesPageSize: "Righe per pagina",
    preferencesColumns: "Colonne",
    preferencesColumnsHint:
      "Trascina per riordinare. Deseleziona per nascondere una colonna.",
    preferencesConfirm: "Conferma",
    preferencesCancel: "Annulla",
    preferencesReset: "Ripristina predefinite",
    reorderColumn: "Riordina colonna",
    selectRow: "Seleziona riga",
    selectionColumn: "Selezione",
    selectionHint: "Usa le caselle a sinistra per selezionare le righe.",
    selectedCount: "{{count}} selezionati",
    selectAllOnPage: "Seleziona tutti in pagina",
    clearSelection: "Deseleziona",
  },
} as const;
